import React from 'react';
import './NewsAbout1.css'
import Grid from '@mui/material/Grid';
import { textAlign } from '@mui/system';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

const NewsAbout1 = () => {
    return (
        <div className="container py-5">


        <Box className='news1-box' sx={{ bgcolor: '#cfe8fc', height: '100%' }}>
        <div >
           
           <h1 className="news1-heading">Micro Entrepreneurship Program for the Poor <br /> Women in Bangladesh </h1>
           <p sx={{textAlign: 'justify', color: '#354252' }} className="news1 container fs-6">We are happy to share that we have signed an MoU with Zhumka Bangladesh (NGO with 20 years long working experience in Bangladesh) to work for the development of poor/unprivileged women in rural areas of Bangladesh. Study shows that a huge number of skilled and semi skilled women are struggling for livelihood in rural level (especially in our target areas) who are very much passionate to do something. They just need skills up-gradation, business management training and a sustainable platform to do so.
The support we are planning to do is the best way for them to move forward and improve their living standard. Zhumka Bangladesh has already provided skills training to them on Tailoring, Jute Products, Bamboo Products, Cane Products, Wooden Products, Cultural handicrafts etc. to 5000 (approx.) women and they are eagerly waiting to start their own business in small scale!
<br />
<br />
<h6 className='list-item text-primary'> Our planning:</h6>
<ul sx={{textAlign: 'justify', color: '#354252' }} className="news1 container fs-6">
<li className='list-item'>To provide a suitable Basic Business Training</li>
  <li className='list-item'>To provide Basic Machineries, Raw Materials, Working Capital to start their own business 
</li>
  <li className='list-item'>To establish market place in Bangladesh and Japan to introduce their quality products and ensure a regular sale zone
</li>
  <li className='list-item'>To provide necessary guidance for business operations, they will be under our close monitoring and follow up for 3 years 
</li>
</ul>

This is a donation base project. Any one can contribute in this project who is eager to support poor women for their better livelihood. You can donate for at least 1 woman!

<br />


As we are working on Entrepreneurship Development to solve the social problems, we have decided to help them to overcome their obstacles and free them from poverty.
<br />
<br />
MoU signing ceremony was held on 26th January 2021 at Zhumka Bangladesh Office, Dhaka, Bangladesh. Ms Shirin Jahan, Executive Director of Uddog o Uddokta Foundation, Bangladesh, Ms Samira Hossain, Director, Uddog o Uddokta Japan Association, Ms Sharmin Kabir Bina, Executive Director of Zhumka Bangladesh, Ms Shegufta Nadi, Director of Zhumka Bangladesh and Mr Monir Hossain, Program Manager of Zhumka Bangladesh was present in the ceremony.

</p>
</div>
            </Box> 
        
      
        
  
                {/* <h1 className="news1-heading">Micro Entrepreneurship Program for the Poor Women in Bangladesh </h1>
            <Grid container spacing={2}>
        <Grid className="my-5 py-5 container" item xs={8}>
        <div >
           
           <h1 className="news1-heading">Micro Entrepreneurship Program for the Poor Women in Bangladesh </h1>
           <p sx={{textAlign: 'justify', color: '#354252' }} className="news1 container fs-6">We are happy to share that we have signed an MoU with Zhumka Bangladesh (NGO with 20 years long working experience in Bangladesh) to work for the development of poor/unprivileged women in rural areas of Bangladesh. Study shows that a huge number of skilled and semi skilled women are struggling for livelihood in rural level (especially in our target areas) who are very much passionate to do something. They just need skills up-gradation, business management training and a sustainable platform to do so.
The support we are planning to do is the best way for them to move forward and improve their living standard. Zhumka Bangladesh has already provided skills training to them on Tailoring, Jute Products, Bamboo Products, Cane Products, Wooden Products, Cultural handicrafts etc. to 5000 (approx.) women and they are eagerly waiting to start their own business in small scale!
<br />
<br />
<h6 className='list-item text-primary'> Our planning:</h6>
<ul sx={{textAlign: 'justify', color: '#354252' }} className="news1 container fs-6">
<li className='list-item'>To provide a suitable Basic Business Training</li>
  <li className='list-item'>To provide Basic Machineries, Raw Materials, Working Capital to start their own business 
</li>
  <li className='list-item'>To establish market place in Bangladesh and Japan to introduce their quality products and ensure a regular sale zone
</li>
  <li className='list-item'>To provide necessary guidance for business operations, they will be under our close monitoring and follow up for 3 years 
</li>
</ul>

This is a donation base project. Any one can contribute in this project who is eager to support poor women for their better livelihood. You can donate for at least 1 woman!

<br />


As we are working on Entrepreneurship Development to solve the social problems, we have decided to help them to overcome their obstacles and free them from poverty.
<br />
<br />
MoU signing ceremony was held on 26th January 2021 at Zhumka Bangladesh Office, Dhaka, Bangladesh. Ms Shirin Jahan, Executive Director of Uddog o Uddokta Foundation, Bangladesh, Ms Samira Hossain, Director, Uddog o Uddokta Japan Association, Ms Sharmin Kabir Bina, Executive Director of Zhumka Bangladesh, Ms Shegufta Nadi, Director of Zhumka Bangladesh and Mr Monir Hossain, Program Manager of Zhumka Bangladesh was present in the ceremony.

</p> */}

{/* <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScNbaX7AWA9BhXA3C3UEh7zEeeRUeehEPYWdIakfwJkgo94Aw/viewform?embedded=true" width="640" height="2453" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe> */}

   

{/* 
      <img src="https://www.coninco.com.vn/sites/default/files/HTQT_100_17_coninco2.jpg" alt="" />


       </div>
        </Grid>
        <Grid className=' outline-text my-5 py-5' item xs={4}>
        <div>
               <img className='img-news1 my-2' height={350} width="100%" src="https://www.coninco.com.vn/sites/default/files/HTQT_100_17_coninco2.jpg" alt="" />
           </div>
        </Grid>
      </Grid>
   */}
       
         

       
   
       


       
   </div>
    );
};

export default NewsAbout1;